import { MyAreaStepperWidgetProps } from '@msc-b2c/interfaces/types';
import { getActiveSession, useGetBookingQuery } from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';
import { StepperWidget } from './StepperWidget';
import { LoginMode } from '@msc-b2c/interfaces/enums';

export function StepperWidgetWrapper({ steps }: Readonly<MyAreaStepperWidgetProps>) {
  const { bookingNumber = '', loginMode } = getActiveSession();

  const bookingQuery = useGetBookingQuery(bookingNumber || skipToken);
  const booking = bookingNumber !== '' ? bookingQuery?.data : undefined;

  return booking && loginMode === LoginMode.FULL && <StepperWidget steps={steps} />;
}
export default StepperWidgetWrapper;

StepperWidgetWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/stepperwidget';
